import {baseURL, reqGetWithParams } from "./axiosCreator"

const securityService = "/security"

// export const getImageVerifyCode = `${baseURL}${securityService}/imageVerifyCode`;

export const getImageVerifyCode = ( teleNum, time ) => { return `${baseURL}${securityService}/imageVerifyCode/${teleNum}?timestamp=${time}`  }

// export const sendMobileVerifyCode = ( params, data ) => { return _req("GET", `${securityService}/sendMobileVerifyCode`, params , data )}

//传的不是data是， param-即 路径参数data
export const sendMobileVerifyCode = ( params ) => { return reqGetWithParams("GET", `${securityService}/sendMobileVerifyCode`, params)}